// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type { PostAiModelsPromptPolishBody, BaseResponseint } from '../../../types';

/**
 * 提示词任务提交
 *
 * @export
 * @tags ai-model-controller
 * @link [POST] /aiModels/prompt/polish
 */
export function postAiModelsPromptPolish(
    data: PostAiModelsPromptPolishBody
): Promise<BaseResponseint>;
export function postAiModelsPromptPolish(
    data: PostAiModelsPromptPolishBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseint>;
export function postAiModelsPromptPolish(
    data: PostAiModelsPromptPolishBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseint> {
    return request<PostAiModelsPromptPolishBody, never, never>('/aiModels/prompt/polish', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postAiModelsPromptPolish',
    });
}

export const meta = [
    { tags: ['ai-model-controller'], path: '/aiModels/prompt/polish', method: 'post' },
];
